import React, { useState,useRef,useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { configData } from "../config";
import "./classes/Sales.css";
import "./classes/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCheck, faXmark, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet';
import { useReactToPrint } from "react-to-print";
import { toWords } from 'number-to-words';
import { Modal, Box, Button } from "@mui/material";
import {useNavigate, useParams } from 'react-router-dom';

const EditSales = () => {

    const app_url = configData.APP_URL;
    var {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        fetchOrderItems();
    }, []);

    const [companyDetail, setCompanyDetail] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [options, setOptions] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [customerSearch, setCustomerSearch] = useState("");
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [qty, setQty] = useState(1);
    const [unitCost, setUnitCost] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [lines, setLines] = useState([]);
    const [customerType, setCustomerType] = useState("retail");
    const [paymentType, setPaymentType] = useState("cash");
    const [taxType, setTaxType] = useState("intra");
    const [openStockModal, setOpenStockModal] = useState(false);
    const [selectedStockProduct, setSelectedStockProduct] = useState(null);
    const [stockValue, setStockValue] = useState("");
    const stockInputRef = useRef(null);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (openStockModal) {
        // A tiny timeout ensures the Modal is fully rendered in the DOM
        setTimeout(() => {
            stockInputRef.current?.focus();
        }, 100);
        }
    }, [openStockModal]);


    const handleAddStock = async () => {
    console.log("Add stock:", stockValue, selectedStockProduct);

    if (!stockValue || !selectedStockProduct) {
        alert("Please select product and enter stock value");
        return;
    }

    try {
        const response = await fetch(app_url+'salesapi/addstock', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            item_id: selectedStockProduct?.id,
            quantity_stock:Number(stockValue),
        }),
        });

        const data = await response.json();

        if (!response.ok) {
        throw new Error(data.message || "Failed to add stock");
        }

        console.log("Success:", data);
        alert("Stock added successfully");

        // Reset UI
        setOpenStockModal(false);
        setStockValue("");

    } catch (error) {
        console.error("Error:", error);
        alert(error.message || "Something went wrong");
    }
    };

    const inputSearchRef = useRef(null);
    useEffect(() => {
    if (companyDetail && inputSearchRef.current) {
        setTimeout(() => {
        inputSearchRef.current.focus();
        }, 150);
    }
    }, [companyDetail]);

    useEffect(() => {
    if (!customerSearch?.trim()) {
        setCustomerOptions([]);
        return;
    }

    const timer = setTimeout(async () => {
        try {
        const res = await fetch(
            app_url + "salesapi/getcustomerlist?query=" + customerSearch
        );
        const data = await res.json();
        setCustomerOptions(data || []);
        } catch (err) {
        console.error("Customer fetch error", err);
        }
    }, 400);

    return () => clearTimeout(timer);
    }, [customerSearch]);
    useEffect(() => {
        const fetchData = async () => {
        if (searchValue.trim() === '') {
            setOptions([]); // Clear options if search is empty
            return;
        }
        try {
            const response = await fetch(app_url+'items/getproductlist?query='+searchValue+'&type='+customerType);
            const data = await response.json();
            setOptions(data); 
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        };

        const handler = setTimeout(() => {
        fetchData();
        }, 500); // Debounce for 500ms

        return () => {
        clearTimeout(handler);
        };
    }, [searchValue,customerType]);
    const handleCustomerTypeChange = (e) => {
    setCustomerType(e.target.value);
    setOptions([]); // reset prices 
    };
        
    const fetchOrderItems = async () => {
    try {
        const res = await fetch(`${app_url}salesapi/view-sales?id=${id}`);
        const data = await res.json();

        const formattedLines = data.data.items.map(item => {
        const quantity = Number(item.quantity);
        const price = Number(item.price);

        const taxOnePercent = Number(item.tax_one || 0);
        const taxTwoPercent = Number(item.tax_two || 0);

        const totalTaxPercent = taxOnePercent + taxTwoPercent;

        // IMPORTANT: match your addLine logic
        const lineTotal = quantity * price;
        // const lineSubTotal = lineTotal / (1 + totalTaxPercent / 100);
        const lineSubTotal = parseFloat((lineTotal / (1 + totalTaxPercent / 100)).toFixed(2));

        const lineTaxOne = (lineSubTotal * taxOnePercent) / 100;
        const lineTaxTwo = (lineSubTotal * taxTwoPercent) / 100;

        return {
            id: item.item_id,
            product: item.item_name,
            barcode: item.barcode,

            qty: quantity,
            unitCost: price,

            tax_one: taxOnePercent,
            tax_two: taxTwoPercent,

            lineSubTotal,
            lineTaxOne,
            lineTaxTwo,
            lineTotal: lineSubTotal + lineTaxOne + lineTaxTwo
        };
        });

        setLines(formattedLines);
        setSelectedCustomer({
        id: data.data.sale.customer_id,
        name: data.data.sale.customer_name
        });

        setCustomerSearch(data.data.sale.customer_name || "");
        setCustomerType(data.data.sale.type);
        setPaymentType(data.data.sale.payment_type);
        setTaxType(data.data.sale.tax_type);

    } catch (err) {
        console.error("Error fetching invoice:", err);
    }
    };

    const handleKeyDown = async (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    if (selectedProduct) {
        addLineFromProduct(selectedProduct);
        return;
    }

    if (!searchValue.trim()) return;

    try {
        const res = await fetch(app_url+'items/getproductlist?query='+searchValue);
        const data = await res.json();

        if (data?.length === 1) {
        addLineFromProduct(data[0]);
        }
    } catch (err) {
        console.error(err);
    }
    };

    const focusProductInput = () => {
    setTimeout(() => {
        inputSearchRef.current?.focus();
    }, 50);
    };

    const addLineFromProduct = (product) => {
    setLines(prevLines => {
        const price = unitCost || product.unitCost;
        const quantity = Number(qty);
        const hsn_code = product.hsn_code;
        const unit = product.unit;
        const taxOnePercent = Number(product.tax_one || 0); 
        const taxTwoPercent = Number(product.tax_two || 0); 

        const lineTotal = quantity * price;

        const totalTaxPercent = taxOnePercent + taxTwoPercent;
        // const lineSubTotal = quantity * price;
        // const lineSubTotal = lineTotal / (1 + totalTaxPercent / 100);
        const lineSubTotal = parseFloat((lineTotal / (1 + totalTaxPercent / 100)).toFixed(2));

        const lineTaxOne = (lineSubTotal * taxOnePercent) / 100;
        const lineTaxTwo = (lineSubTotal * taxTwoPercent) / 100;

        const existingLine = prevLines.find(
        line => line.barcode === product.barcode
        );

        if (existingLine) {
        return prevLines.map(line => {
            if (line.barcode !== product.barcode) return line;

            const newQty = line.qty + quantity;
            const newSub = newQty * price;
            const newTaxOne = (newSub * taxOnePercent) / 100;
            const newTaxTwo = (newSub * taxTwoPercent) / 100;

            return {
            ...line,
            qty: newQty,
            hsn_code: hsn_code,
            unit: unit,
            lineSubTotal: newSub,
            lineTaxOne: newTaxOne,
            lineTaxTwo: newTaxTwo,
            lineTotal: newSub + newTaxOne + newTaxTwo
            };
        });
        }

        return [
        ...prevLines,
        {
            id: product.id,
            product: product.name,
            barcode: product.barcode,
            hsn_code: product.hsn_code,
            unit: product.unit,
            qty: quantity,
            unitCost: price,

            tax_one: taxOnePercent,
            tax_two: taxTwoPercent,

            lineSubTotal,
            lineTaxOne,
            lineTaxTwo,
            lineTotal: lineSubTotal + lineTaxOne + lineTaxTwo
        }
        ];
    });

    setSelectedProduct(null);
    setSearchValue("");
    setQty(1);
    setUnitCost(0);
    focusProductInput();
    };



    const updateLine = (id, field, value) => {
    setLines(prev =>
        prev.map(line => {
        if (line.id !== id) return line;

        const updated = { ...line, [field]: Number(value) };

        const total = updated.qty * updated.unitCost;

        // total GST %
        const totalTaxPercent = (updated.tax_one || 0) + (updated.tax_two || 0);

        // base (excluding GST)
        const sub = total / (1 + totalTaxPercent / 100);

        // split taxes from base
        const tax1 = (sub * updated.tax_one) / 100;
        const tax2 = (sub * updated.tax_two) / 100;

        return {
            ...updated,
            lineSubTotal: sub,
            lineTaxOne: tax1,
            lineTaxTwo: tax2,
            lineTotal: total // already includes GST
        };
        })
    );
    };

    const removeLine = (id) => {
        setLines(prev => prev.filter(line => line.id !== id));

        setTimeout(() => {
        inputSearchRef.current?.focus();
        }, 0);
    };
    
    const subTotal = lines.reduce((s, l) => s + l.lineSubTotal, 0);

    const totalTaxOne = Number(lines.reduce((sum, line) => sum + (line.lineTaxOne || 0),0).toFixed(2));

    const totalTaxTwo = Number(lines.reduce((sum, line) => sum + (line.lineTaxTwo || 0),0).toFixed(2));
    const totalTax = totalTaxOne + totalTaxTwo;
    const grandTotal = subTotal + totalTax;

    const roundedTotal = Math.round(grandTotal); 

    const roundOff = Math.round((roundedTotal - grandTotal) * 100) / 100;

    const handleSubmit = async (shouldPrint = false) => {
    if (isSubmitting) return;
    if (lines.length === 0) {
        alert("Add at least one product");
        return;
    }

    setIsSubmitting(true);

    const payload = {
    total_amount: Number(roundedTotal.toFixed(2)),
    sub_total: Number(subTotal.toFixed(2)),
    sgst: Number(totalTaxOne.toFixed(2)),
    cgst: Number(totalTaxTwo.toFixed(2)),
    igst:Number(totalTax.toFixed(2)),		
    roundoff: Number(roundOff.toFixed(2)),
    tax: Number((totalTaxOne + totalTaxTwo).toFixed(2)),

    customer_type: customerType,
    customer_id: selectedCustomer?.id || null,
    payment_type: paymentType,
    tax_type:taxType,

    items: lines.map(line => ({
        item_id: line.id,
        item_name:line.product,
        barcode:line.barcode,
        quantity:String(line.qty),
        price: line.unitCost,
        sub_total: line.lineSubTotal,
        sgst: taxType === "intra" ? line.lineTaxOne : 0,
        cgst: taxType === "intra" ? line.lineTaxTwo : 0,
        tax: taxType === "inter"
        ? Number(totalTax.toFixed(2))  
        : Number((line.lineTaxOne + line.lineTaxTwo).toFixed(2)),
        total: line.lineTotal,
    }))
    };
    console.log(payload);
    try {
        const res = await fetch(
        app_url + `salesapi/edit-sales?id=${id}`,
        {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        }
        );

        const data = await res.json();

        if (data.success) {
        alert("Order saved successfully");
        navigate("/sales-report");
        } else {
        alert("Failed to save order");
        }
    } catch (err) {
        console.error(err);
    } finally{
        setIsSubmitting(false);
    }
    };

    const companydetails = async () => {
        try {
        const res = await fetch(app_url + "salesapi/showcom");
        const data = await res.json();
        if (data.company) {
            setCompanyDetail(data.company);
        }
        } catch (error) {
        console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        companydetails();
    }, []);

    if (!companyDetail) return;

    return (
        <div className="purchase-order-page">
            <Helmet>
                <title>Edit Sale</title>
            </Helmet>
        <div className="create-purchase-order-container">
        <div className="po-modal">
        <div className="po-header">
        </div>

        <div className="po-body">
            <div className="row po-summary-row">
                <div className="main-total">
                Total: ₹{roundedTotal.toFixed(2)}
                </div>
            </div>

            <div className="po-options-row">
                <div className="po-option">
                    <label htmlFor="customer-type">Customer Type</label>
                    <select id="customer-type" value={customerType} onChange={handleCustomerTypeChange}>
                    <option value="retail">Retail</option>
                    <option value="wholesale">Wholesale</option>
                    </select>
                </div>
                <div className="po-option" style={{ minWidth: 260 }}>
                    <label>Customer</label>

                    <Autocomplete
                    className="customer-search"
                    options={customerOptions}
                    value={selectedCustomer}
                   // getOptionLabel={(option) => option.name}
                   getOptionLabel={(option) => option?.name || ""}
                    filterOptions={(x) => x}
                    onChange={(e, value) => setSelectedCustomer(value)}
                    inputValue={customerSearch}
                    onInputChange={(e, value) => setCustomerSearch(value)}
                    renderOption={(props, option) => (
                        <li {...props} style={{ display: "flex", flexDirection: "column", padding: "6px 10px" }}>
                        <span style={{ fontWeight: 500, fontSize: "14px", color: "#333" }}>
                            {option.name}
                        </span>
                        <span style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
                            {option.phone_number && <span>Ph: {option.phone_number} </span>}
                            {(option.phone_number && option.gst_number) && <> | </>}
                            {option.gst_number && <span>GST: {option.gst_number}</span>}
                        </span>
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        placeholder="Select customer"
                        size="small"
                        />
                    )}
                    />
                </div>
                <div className="po-option">
                    <label htmlFor="payment-type">Payment Type</label>
                    <select id="payment-type" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                    <option value="cash">Cash</option>
                    <option value="credit">Credit</option>
                    </select>
                </div>
                <div className="po-option">
                    <label htmlFor="tax">Tax</label>
                    <select id="tax" value={taxType} onChange={(e) => setTaxType(e.target.value)}>
                    <option value="intra">SGST + CGST</option>
                    <option value="inter">IGST</option>
                    </select>
                </div>
            </div>
            <Modal open={openStockModal} onClose={() => setOpenStockModal(false)}>
                <Box
                    sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 300,
                    bgcolor: "white",
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 24
                    }}
                >
                    {/* <h3>Add Stock</h3> */}

                    <h3>{selectedStockProduct?.name}</h3>

                    <TextField
                    fullWidth
                    inputRef={stockInputRef} 
                    type="number"
                    label="Enter Stock"
                    value={stockValue}
                    onChange={(e) => setStockValue(e.target.value)}
                    sx={{ mt: 2 }}
                    />

                    <Button
                    variant="contained"
                    fullWidth
                    style={{ backgroundColor: "#E03F5B" }}
                    sx={{ mt: 2 }}
                    onClick={handleAddStock}
                    >
                    Save
                    </Button>
                </Box>
            </Modal>
            <div className="add-line">
                <div>
                    <p>Product</p>
                    <div className="pos-autocomplete-search">
                    <Autocomplete 
                    disablePortal   
                    className="pos-autocomplete"          
                    options={options}
                    getOptionLabel={(option) => option.name}
                    value={selectedProduct}
                    inputValue={searchValue}
                    onInputChange={(e, value) => setSearchValue(value)}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    onChange={(e, value) => {
                        if (!value) return;

                        // 1. STOCK LOGIC
                        if (value.quantity_stock === 0) {
                        setSelectedStockProduct(value);
                        setOpenStockModal(true);
                        setSelectedProduct(null); 
                        return;
                        }
                        setSelectedProduct(value);
                        setUnitCost(value.unitCost);

                        setOptions([]); 
                        setSearchValue("");  
                    }}

                    renderOption={(props, option) => {
                        const { onClick, ...otherProps } = props;
                        return (
                        <li
                        {...otherProps}
                        onClick={(e) => {
                        if (option.quantity_stock === 0) {
                            e.stopPropagation(); // Stop MUI from selecting it
                            setSelectedStockProduct(option); // Prep the modal
                            setOpenStockModal(true); // Open the modal
                            return;
                        }
                        onClick(e); // Otherwise, do the normal selection
                        }}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            opacity: option.quantity_stock === 0 ? 0.5 : 1,
                            cursor: option.quantity_stock === 0 ? "not-allowed" : "pointer"
                        }}
                        >
                        <strong>{option.name}</strong>&nbsp;&nbsp;-&nbsp;
                        <span style={{ marginLeft: 10, color: "#666" }}>
                            ₹{option.unitCost}
                        </span>

                        <span
                            style={{
                            marginLeft: 10,
                            color: option.quantity_stock === 0 ? "red" : "#666"
                            }}
                        >
                            (Stock: {option.quantity_stock})
                        </span>

                        {/* 3. The button is now just a visual hint since the whole row works */}
                        {option.quantity_stock === 0 && (
                        <span style={{ marginLeft: 10, fontSize: '0.8rem', background: '#ff9800', color: '#fff', padding: '2px 6px', borderRadius: '4px' }}>
                            Restock
                        </span>
                        )}

                        </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        inputRef={inputSearchRef}  
                        placeholder="Search or scan barcode"

                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                            // If the dropdown is visible, let MUI handle the selection.
                            // Once the dropdown closes (after selection), this block is skipped.
                            if (open && options.length > 0) {
                                return; 
                            }
                            }

                            // Now, if the dropdown is closed, this will run on the next Enter press
                            handleKeyDown(e);
                        }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                            <div className="pos-end-adornment">
                                {params.InputProps.endAdornment}
                            </div>
                            ),
                        }}
                        />
                    )}
                    />
                    </div>
                </div>
                <div>
                    <p>Qty</p>
                    <input
                    type="number"
                    min="1"
                    value={qty}
                    onChange={e => setQty(e.target.value)}
                    onWheel={(e) => {
                        e.preventDefault();
                        e.currentTarget.blur(); 
                    }}
                    />
                </div>
                <div>
                    <p>Unit Cost (₹)</p>
                    <input
                    type="number"
                    step="0.01"
                    value={unitCost}
                    onChange={e => setUnitCost(e.target.value)}
                    onWheel={(e) => {
                        e.preventDefault();
                        e.currentTarget.blur(); 
                    }}
                    />
                </div>
                <button onClick={() => selectedProduct && addLineFromProduct(selectedProduct)} className="add-line-button" style={{cursor:"pointer"}}>
                    <FontAwesomeIcon icon={faPlus} /> Add Line
                </button>

            </div>
            
            <div className="purchase-table">
                <div className="purchase-table-desktop">
                    <table>
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Unit Cost</th>
                            <th>Line Total</th>
                            <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lines.length > 0 ? (<>
                            {lines.map((line, index) => (
                            <tr key={line.id}>
                                <td>{index + 1}</td>
                                <td>{line.product}</td>
                                <td>
                                <input
                                    type="number"
                                    value={line.qty}
                                    onChange={e => updateLine(line.id, "qty", e.target.value)}
                                    onWheel={(e) => {
                                    e.preventDefault();
                                    e.currentTarget.blur(); 
                                    }}
                                />
                                </td>
                                <td>
                                <input
                                    type="number"
                                    value={line.unitCost}
                                    onChange={e =>
                                    updateLine(line.id, "unitCost", e.target.value)
                                    }
                                    onWheel={(e) => {
                                    e.preventDefault();
                                    e.currentTarget.blur(); 
                                    }}
                                />
                                </td>
                                <td>₹{line.lineSubTotal.toFixed(2)}</td>
                                <td><FontAwesomeIcon style={{color:"red",cursor:"pointer"}} icon={faXmark} onClick={() => removeLine(line.id)}/>
                                </td>
                            </tr>
                            ))}
                            </>):(<tr><td colSpan={6}>No items yet</td></tr>)}
                        </tbody>
                        <tfoot className="po-table-footer">
                            <tr>
                                <td colSpan={4} className="po-footer-label">Sub Total</td>
                                <td className="po-footer-value">₹{subTotal.toFixed(2)}</td>
                                <td></td>
                            </tr>

                            {taxType === "intra" ? (
                                    <>
                                <tr>
                                    <td colSpan={4} className="po-footer-label">SGST</td>
                                    <td className="po-footer-value">₹{totalTaxOne.toFixed(2)}</td>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td colSpan={4} className="po-footer-label">CGST</td>
                                    <td className="po-footer-value">₹{totalTaxTwo.toFixed(2)}</td>
                                    <td></td>
                                </tr>
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan={4} className="po-footer-label">IGST</td>
                                        <td className="po-footer-value">₹{totalTax.toFixed(2)}</td>
                                        <td></td>
                                    </tr>
                                    )}

                            <tr>
                                <td colSpan={4} className="po-footer-label">Round Off</td>
                                <td className="po-footer-value">{roundOff.toFixed(2)}</td>
                                <td></td>
                            </tr>

                            <tr className="po-footer-grand">
                                <td colSpan={4} className="po-footer-label">Grand Total</td>
                                <td className="po-footer-value">₹{roundedTotal.toFixed(2)}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            <div className="purchase-cards-mobile">
                {lines.length > 0 ? (
                <>
                    {lines.map((line, index) => (
                    <div key={line.id} className="po-line-card">
                        <div className="po-line-card-header">
                        <span className="po-line-card-product">{line.product}</span>
                        <button type="button" className="po-line-card-remove" onClick={() => removeLine(line.id)} aria-label="Remove">
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                        </div>
                        <div className="po-line-card-body">
                        <div className="po-line-card-field">
                            <label>Qty</label>
                            <input
                            type="number"
                            min="1"
                            value={line.qty}
                            onChange={e => updateLine(line.id, "qty", e.target.value)}
                            onWheel={(e) => {
                                e.preventDefault();
                                e.currentTarget.blur(); 
                            }}
                            />
                        </div>
                        <div className="po-line-card-field">
                            <label>Unit Cost (₹)</label>
                            <input
                            type="number"
                            step="0.01"
                            value={line.unitCost}
                            onChange={e => updateLine(line.id, "unitCost", e.target.value)}
                            onWheel={(e) => {
                                e.preventDefault();
                                e.currentTarget.blur(); 
                            }}
                            />
                        </div>
                        <div className="po-line-card-total">
                            ₹{line.lineSubTotal.toFixed(2)}
                        </div>
                        </div>
                    </div>
                    ))}
                    <div className="po-cards-summary">
                    <div className="po-summary-row">
                        <span>Sub Total</span>
                        <span>₹{subTotal.toFixed(2)}</span>
                    </div>

                     {taxType === "intra" ? (
                        <>
                        <div className="po-summary-row">
                            <span>SGST</span>
                            <span>₹{totalTaxOne.toFixed(2)}</span>
                        </div>

                        <div className="po-summary-row">
                            <span>CGST</span>
                            <span>₹{totalTaxTwo.toFixed(2)}</span>
                        </div>
                            </>
                    ) : (
                        <div className="po-summary-row">
                            <span>IGST</span>
                            <span>₹{totalTax.toFixed(2)}</span>
                            </div>
                        )}

                    <div className="po-summary-row">
                        <span>Round Off</span>
                        <span>₹{roundOff.toFixed(2)}</span>
                    </div>

                    <div className="po-summary-row po-summary-total">
                        <span>Total</span>
                        <span>₹{roundedTotal.toFixed(2)}</span>
                    </div>
                    </div>
                </>
                ) : (
                <div className="po-cards-empty">No items yet</div>
                )}
            </div>
            </div>

            <div className="billing-actions" style={{textAlign:"right"}}>
            <a className="cancel" href="/sales-report" style={{cursor:"pointer"}}>Cancel</a>&nbsp;
            <button className="save" disabled={isSubmitting} style={{ cursor: "pointer" }} onClick={() => handleSubmit(false)} >
                <FontAwesomeIcon icon={faCheck} />  {isSubmitting ? "Saving..." : "Save Order"}</button>&nbsp;
            </div>
        </div>
        </div>
        </div>
        </div>
        
    );
};

export default EditSales;